import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable, map } from 'rxjs';

import { FinnairBoundItem, FinnairOrder } from '@fcom/dapi/api/models';
import { IconPosition, ButtonTheme, IconButtonTheme } from '@fcom/ui-components/index';
import { MediaQueryService } from '@fcom/common/services';
import { NativeBridgeService } from '@fcom/core/services';

@Component({
  selector: 'fin-check-in-subheader',
  templateUrl: 'check-in-subheader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckInSubheaderComponent implements OnInit {
  readonly ButtonTheme = ButtonTheme;
  readonly IconButtonTheme = IconButtonTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly IconPosition = IconPosition;

  isInsideApp: boolean;

  isMobile$: Observable<boolean>;
  isLaptopUp$: Observable<boolean>;

  exitCheckInTextKey$: Observable<string>;

  @Input() bound: FinnairBoundItem;
  @Input() locations: FinnairOrder['locations'];
  @Output() exitCheckIn: EventEmitter<void> = new EventEmitter<void>();
  @Output() viewFlightDetails: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private mediaQueryService: MediaQueryService,
    private nativeBridgeService: NativeBridgeService
  ) {}

  ngOnInit(): void {
    this.isInsideApp = this.nativeBridgeService.isInsideNativeWebView;
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
    this.isLaptopUp$ = this.mediaQueryService.isBreakpoint$('laptop_up');

    this.exitCheckInTextKey$ = this.isMobile$.pipe(
      map((isMobile) => `MMB.checkIn.funnel.navigationBar.exitCheckIn${isMobile ? 'Mobile' : ''}`)
    );
  }
}
